var map = {
	"./athon/logo.png": "eeb8",
	"./automa/logo.png": "33ab",
	"./bulbe/logo.png": "2402",
	"./contour/logo.png": "da73",
	"./cpflr/logo.png": "1880",
	"./delta/logo.png": "bde7",
	"./energimp/logo.png": "8a96",
	"./enerside/logo.png": "1d58",
	"./essentia/logo.png": "979c",
	"./ibitu/logo.png": "30e5",
	"./jaiba/logo.png": "d04e",
	"./lavras2/logo.png": "1a11",
	"./omega/logo.png": "0e33",
	"./origo/logo.png": "9d1a",
	"./prodiel/logo.png": "b98c",
	"./renova/logo.png": "d0df",
	"./salgueiro/logo.png": "d08d",
	"./serveng/logo.png": "0f08",
	"./statkraft/logo.png": "01de",
	"./tradener/logo.png": "a270",
	"./voltalia/logo.png": "8df2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f077";